import { Component, Input } from '@angular/core';
import { BatteryTypeOption } from 'src/app/_shared/utils/battery-type';

@Component({
  selector: 'app-dutycycle-fleet',
  templateUrl: './dutycycle-fleet.component.html',
  styleUrls: ['./dutycycle-fleet.component.scss']
})
export class DutycycleFleetComponent {
  @Input() fleetId: string[] = [];
  @Input() selectedBatteryTypes: BatteryTypeOption[] = [];
  @Input() companyData: any;
  @Input() isMetric: boolean | undefined;
  
  constructor() { }
}